export const mapUsers = (serverResponse) => [...serverResponse.map(
    item => ({
        userEmail: item.email,
        user:item.name,
        role:item.roles.name? [item.roles.name] : item.roles.map((c) => c.name) ? item.roles.map((c) => c.name) : "NA",
        reportsTo:item.hierarchy[0] ? item.hierarchy[0].name : "NA",
        id: item._id,
        status:item.status
    }))];